import { render, staticRenderFns } from "./Inhabilitar.vue?vue&type=template&id=79e7fbda"
import script from "./Inhabilitar.vue?vue&type=script&lang=js"
export * from "./Inhabilitar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports